import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { FIREBASE_CONFIG } from "../config";

const app = initializeApp(FIREBASE_CONFIG);

export const db   = getFirestore(app);
export const auth = getAuth(app);
